export default __webpack_public_path__ + "static/media/banner-35.49adbb94.jpg";